import { render } from "./CheckDataPage.vue?vue&type=template&id=502bea06&scoped=true"
import script from "./CheckDataPage.vue?vue&type=script&lang=js"
export * from "./CheckDataPage.vue?vue&type=script&lang=js"

import "./CheckDataPage.vue?vue&type=style&index=0&id=502bea06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502bea06"]])

export default __exports__